import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ElementRef,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CimSubstationService } from '../../../../../services/cim-substation.service';
import { SubstationTemplateService } from '../../../../../services/substation-template.service';
import { UtilitySharedService } from '../../../../../services/shared/utility-shared.service';
import { SelectSubstationDataIn } from '../../../../../models/substation-template-instance.model';
import { PowerTransformerService } from '../../../../../services/power-transformer.service';
import { ObjectDropdownComponent } from '../../../../common/object-dropdown/object-dropdown.component';

@Component({
  selector: 'lib-nec-add-incomming-line-to-ss-modal',
  templateUrl: './nec-add-incomming-line-to-ss-modal.component.html',
  standalone: false,
  styleUrl: './nec-add-incomming-line-to-ss-modal.component.scss',
})
export class NecAddIncommingLineToSsModalComponent implements OnInit {
  updatedParentSubstationId: number | null = null;
  parentSubstations: any[] = [];
  outgoingAcLineSegments: any[] = [];
  powerTransformersOnSS: any[] = [];
  powerTransformersOnSSFiltered: any[] = [];
  utilityId!: number;
  updatedAcLineOutgoing: any | null = null;
  powerTransformerId: number | null = null;
  @Input() substationId: any;
  @ViewChild('closeEditModal') closeEditModal?: ElementRef;

  @Output() acLineSegmentSaved = new EventEmitter<void>();
  @ViewChild('parentSubstationDropdown')
  parentSubstationDropdown!: ObjectDropdownComponent;
  @ViewChild('acLineDropdown')
  acLineDropdown!: ObjectDropdownComponent;
  @ViewChild('powerTransformerDropdown')
  powerTransformerDropdown!: ObjectDropdownComponent;

  ngOnInit(): void {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
    this.getAllParentSubstationsForSelect(new SelectSubstationDataIn(''));
    // this.getPowerTransformersBySubstationIdAndVoltage(this.substationId);
  }
  constructor(
    private toastr: ToastrService,
    private powerTransformerService: PowerTransformerService,
    private utilitySharedService: UtilitySharedService,
    private cimSubstationService: CimSubstationService,
  ) {}
  onSelectParentSubstation(obj: any | null) {
    if (obj) {
      this.updatedParentSubstationId = obj.id;
      this.getAllOutgoingLines(obj.id ?? 0);
    }
  }
  onSearchTextChange(inputText: string) {
    if (this.parentSubstations.length !== 0) {
      this.getAllParentSubstationsForSelect(
        new SelectSubstationDataIn(inputText),
      );
    }
  }
  getPowerTransformersBySubstationIdAndVoltage(): void {
    let obj = {
      substationId: this.substationId,
      baseVoltageId: this.updatedAcLineOutgoing.baseVoltageId,
    };

    this.powerTransformerService
      .getPowerTransformersBySubstationIdAndVoltage(obj)
      .subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData?.status === 'OK' && responseData?.data) {
            const data = responseData.data;
            this.powerTransformersOnSS = data;
            if (this.powerTransformersOnSS.length == 0)
              this.toastr.warning(
                'No Power Transformer in the substation is capable of accepting the selected line. Please create a new Power Transformer with the appropriate voltage on the primary winding',
              );
          } else {
            this.toastr.error(responseData.message);
          }
        },
        error: () => {
          this.toastr.error(
            'Error occurred while loading Power Transformer data',
          );
        },
      });
  }
  getAllParentSubstationsForSelect(dataIn: SelectSubstationDataIn) {
    this.cimSubstationService.getForSelect(dataIn).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.parentSubstations = responseData.data.map(
            (parentSubstation: any) => ({
              ...parentSubstation,
            }),
          );
        } else if (response?.status === 204) {
          this.parentSubstations = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading parent substations');
      },
    });
  }
  getAllOutgoingLines(substationId: number) {
    this.cimSubstationService.getOutgoingLines(substationId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.outgoingAcLineSegments = responseData.data.map(
            (outgoingAcLineSegment: any) => ({
              ...outgoingAcLineSegment,
            }),
          );
        } else if (response?.status === 204) {
          this.outgoingAcLineSegments = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error(
          'Error occurred while loading outgoing ac line segments',
        );
      },
    });
  }
  onSelectAcLineOutoging(obj: any | null) {
    if (obj) {
      this.updatedAcLineOutgoing = obj;
      this.getPowerTransformersBySubstationIdAndVoltage();
    }
  }

  onSelectPowerTransformer(obj: any | null) {
    if (obj) {
      this.powerTransformerId = obj.id;
    }
  }
  save() {
    var obj = {
      powerTransformerId: this.powerTransformerId,
      substationId: this.substationId,
      aCLineId: this.updatedAcLineOutgoing.id,
    };
    this.cimSubstationService.addIncommingAcLine(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success('New Incomming AC Line added.');
        } else if (response?.status === 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
        this.closeEditModal?.nativeElement?.click();
        this.acLineSegmentSaved.emit();
        this.resetForm();
      },
      error: (_) => {
        this.toastr.error('Error occurred while adding new incoming acline');
      },
    });
  }
  resetForm() {
    this.updatedParentSubstationId = null;
    this.outgoingAcLineSegments = [];
    this.powerTransformersOnSS = [];
    this.powerTransformerId = null;
    this.updatedAcLineOutgoing = null;
    this.powerTransformersOnSSFiltered = [];
    this.parentSubstationDropdown?.selectItem(null);
    this.acLineDropdown?.selectItem(null);
    this.powerTransformerDropdown?.selectItem(null);
  }
}
